import React, { useEffect, useState } from "react"
import axios from "axios"
import { navigate } from "gatsby"
import { useDispatch, useSelector } from "react-redux"
import mapTranslationsToObject from "@utils/mapTranslationsToObject"
import useWindowHeight from "../../../hooks/window-height"
import { setState } from "../../../ducks/filterProductsSlice"
import { useSiteTranslations } from "@hooks/useSiteTranslations"
import { TextInput } from "../../common/form/TextInput"

import { filterProducts } from "./filterBar.utils"

import * as s from "./FilterBar.module.scss"

import Chevron from "../../../assets/icons/chevron.inline.svg"

export const FilterBar = ({
  unfilteredProducts,
  productCategories,
  currentCategory,
}) => {
  const productsArray = useSelector(state => state.filterProducts.products)
  const [activeSort, setActiveSort] = useState(null)
  const [searchValue, setSearchValue] = useState("")
  const {
    shopTranslations: { shop },
  } = useSiteTranslations()
  const dispatch = useDispatch()

  useEffect(() => {
    if (!activeSort) return
    const products = filterProducts(productsArray, activeSort)

    dispatch(setState({ products: products }))
  }, [activeSort])

  useEffect(() => {
    if (searchValue.length >= 1) {
      const shopifyProducts = () => {
        fetchData(searchValue).then(res => {
          if (res) {
            matchHandle(searchValue, res)
          } else {
            return
          }
        })
      }
      shopifyProducts()
    } else {
      matchHandle(searchValue, null)
    }
  }, [searchValue])

  const matchHandle = (value, shopifyResults) => {
    if (!value || value === "") {
      dispatch(setState({ products: unfilteredProducts }))
    }

    if (shopifyResults) {
      const filteredItems = unfilteredProducts.filter(item =>
        shopifyResults.find(product => product.handle === item.handle),
      )

      dispatch(setState({ products: filteredItems }))
    }
  }

  const fetchData = async searchValue => {
    const shopifyRes = await axios.post(`/.netlify/functions/search-shopify`, {
      searchValue,
      locale: process.env.GATSBY_LOCALE || "uk",
    })

    return shopifyRes.data
  }

  return (
    <div className={s.filterBar}>
      <div className={s.filterBar__searchContainer}>
        <TextInput
          className={`${s.filterBar__search} ${
            searchValue ? s.filterBar__search___active : ""
          }`}
          placeholder={shop.searchInputPlaceholderText}
          onChange={e => setSearchValue(e.target.value)}
          value={searchValue}
        />
      </div>
      <div className={s.filterBar__filtersContainer}>
        <FilterComponent
          options={[
            {
              title: shop.sortBySelectOptions.all,
              handle: "all",
            },
            ...productCategories
              .filter(i => i.handle !== "shop")
              .map(category => {
                const categoryTitle =
                  category.translations.length > 0
                    ? mapTranslationsToObject(category.translations).title
                    : category.title
                return {
                  title: categoryTitle,
                  handle: category.handle,
                }
              }),
          ]}
          title={shop.categoryInputPlaceholderText}
          currentOption={currentCategory}
          onSelect={e => {
            navigate(`/shop${e !== "all" ? `/${e.toLowerCase()}` : `/`}`)
          }}
        />
        <FilterComponent
          options={[
            {
              title: shop.sortBySelectOptions.priceAscending,
              handle: "price-ascending",
            },
            {
              title: shop.sortBySelectOptions.priceDescending,
              handle: "price-descending",
            },
            {
              title: shop.sortBySelectOptions.titleAZ,
              handle: "title-a-z",
            },
            {
              title: shop.sortBySelectOptions.titleZA,
              handle: "title-z-a",
            },
          ]}
          title={shop.sortByInputPlaceholderText}
          currentOption={activeSort}
          onSelect={e => {
            if (e == "all") {
              setActiveSort(null)
            } else {
              setActiveSort(e)
            }
          }}
        />
      </div>
    </div>
  )
}

const FilterComponent = ({ options, onSelect, title, currentOption }) => {
  const [activeOption, setActiveOption] = useState(null)
  const [showOptions, setShowOptions] = useState(false)
  const windowHeight = useWindowHeight()
  const maxHeightOfDropdown = windowHeight - 274
  return (
    <div
      className={`${s.filterComponent} ${
        activeOption || currentOption ? s.filterComponent__active : ""
      }`}
    >
      <div
        onClick={() => {
          setShowOptions(!showOptions)
        }}
      >
        <h4>{title}</h4>
        <span className={s.filterComponent__activeTitle}>
          {currentOption ? currentOption : "all"}
        </span>
      </div>
      <div
        style={{
          maxHeight: showOptions ? `${maxHeightOfDropdown}px` : "0px",
          overflow: "auto",
        }}
        className={`${s.filterComponent__options} ${
          showOptions
            ? s.filterComponent__options___open
            : s.filterComponent__options___closed
        }`}
      >
        {options.map((option, i) => {
          return (
            <div
              key={i}
              className={s.filterComponent__option}
              onClick={() => {
                setShowOptions(false)
                onSelect(option.handle)

                if (option.handle !== "all") {
                  setActiveOption(option.handle)
                } else {
                  setActiveOption(null)
                }
              }}
            >
              <span>{option.title}</span>
            </div>
          )
        })}
      </div>
      <div
        className={`${s.filterComponent__icon} ${
          showOptions ? s.filterComponent__icon___rotate : ""
        }`}
      >
        <Chevron />
      </div>
    </div>
  )
}
